import { Component, OnInit } from '@angular/core';
import { ApiConfiguration } from 'src/app/services/http/api-configuration';
import { ApiService } from 'src/app/services/http/api.service';
import { ToastClientService } from 'src/app/services/toast/toast-client.service';

@Component({
  selector: 'app-reminder-sms',
  templateUrl: './reminder-sms.component.html',
  styleUrls: ['./reminder-sms.component.scss']
})
export class ReminderSmsComponent implements OnInit {


  sec_id = 2;
  moduleName: any = "";
  program_id: any = ""
  moduleList: any = []
  singleModulesDetails: any;



  constructor(
    private apiService: ApiService,
    private apiConfig: ApiConfiguration,
    private toast: ToastClientService
  ) {
    let userData: any = []
    userData = JSON.parse(localStorage.getItem("program"))
    this.program_id = userData.program_id
  }

  ngOnInit() {
    this.getModule();
  }

  getModule() {
    this.apiService.get(this.apiConfig.moduleList).subscribe((res: any) => {
      let module = {
        module_name: "",
        value: "",
      }
      res.data.forEach((e: any) => {
        module.module_name = e
        module.value = e.toLowerCase()
        this.moduleList.push(JSON.parse(JSON.stringify(module)))
      })

    })
  }


  getModuleDetails(moduleName: string) {
    this.apiService.get(this.apiConfig.getMatrixModulesDetails
      + 'section_id=' + this.sec_id + '&module=' + moduleName)
      .subscribe((res: any) => {
        if (res.status == 200) {
          this.singleModulesDetails = res.data;
        }
      },
        (err) => {
          
        }
      );
  }


}
